// extracted by mini-css-extract-plugin
export default {"block":"General_block__jBNDY","avatarWrap":"General_avatarWrap__5CIhq"};